import { $api } from '@shared/api';
import { handleAxiosFetchErrorsSwal } from '@shared/helpers/fetchHelpers';

export const createAdminConversationForm = async (formData: FormData) => {
    // @ts-ignore
    const url = routable.getRoute('adminCommunicationCreate');

    try {
        // @ts-ignore
        loader.show();
        const response = await $api.post(url, formData);
        // @ts-ignore
        loader.hide();
        return response.data;
    } catch (error) {
        // @ts-ignore
        loader.hide();
        handleAxiosFetchErrorsSwal(error?.response?.data);
        return error.message;
    }
};
